<script setup>
import SideBarLogo from "@/components/Dashboard/SideBarLogo.vue";
import SidebarNav from "./SidebarNav.vue";
</script>

<template>
  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <SideBarLogo />
    <SidebarNav />
  </aside>
</template>
